// @flow
import classnames from 'classnames';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import { AVA_DOMAIN, AVA_URL } from '../../../constants';
import RoundedButton from '../../Buttons/RoundedButton';

import SearchAvaRoomInput from '../../Inputs/SearchAvaRoomInput';

import { Notification } from '../../../types/cc-mode';
import { getSnack } from '../../../utils/snackbar';

import useStyles from './InviteCard.styles';

interface Props {
  addNotification: (newNotification: Notification) => void;
  electronCaptionMode: boolean;
  setInviteCardOpen: (isOpen: boolean) => void;
  status: Object;
}

const InviteCard = ({ addNotification, electronCaptionMode, setInviteCardOpen, status }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { closeSnackbar, enqueueSnackbar } = useSnackbar();

  const [currentTabIndex, setCurrentTabIndex] = useState(0);

  return (
    <ClickAwayListener onClickAway={() => setInviteCardOpen(false)}>
      <div className={classes.root}>
        <header className={classes.header}>
          <button
            className={classnames(classes.tab, {
              [classes.activeTab]: currentTabIndex === 0,
            })}
            onClick={() => setCurrentTabIndex(0)}
            disabled={currentTabIndex === 0}
          >
            {t('ccMode.inviteCard.inviteFriends')}
          </button>
          <button
            className={classnames(classes.tab, {
              [classes.activeTab]: currentTabIndex === 1,
            })}
            onClick={() => setCurrentTabIndex(1)}
            disabled={currentTabIndex === 1}
          >
            {t('ccMode.inviteCard.joinARoom')}
          </button>
        </header>
        <section className={classes.panel}>
          {currentTabIndex === 0 && (
            <div className={classes.inviteFriendsPanel}>
              <div className={classes.linkContainer}>
                <span className={classes.avaLink}>
                  {AVA_DOMAIN}/<span className={classes.avaName}>&{status.host.avaName}</span>
                </span>
              </div>
              <RoundedButton
                className={classes.copyLink}
                color="blue"
                onClick={() => {
                  const url = `${AVA_URL}/&${status.host.avaName}`;
                  if (window.navigator.share) {
                    window.navigator.share({ url });
                  } else {
                    navigator.clipboard.writeText(url);
                    if (electronCaptionMode) {
                      addNotification({
                        text: t('addParticipant.theConversationLinkHasBeenCopiedToYourClipboard'),
                        timestamp: Date.now(),
                        type: 'default',
                      });
                    } else {
                      getSnack({ enqueueSnackbar, closeSnackbar })(
                        t('addParticipant.theConversationLinkHasBeenCopiedToYourClipboard')
                      );
                    }
                  }
                  setInviteCardOpen(false);
                }}
              >
                {t('ccMode.inviteCard.copyLink')}
              </RoundedButton>
            </div>
          )}
          {currentTabIndex === 1 && (
            <div className={classes.joinRoomPanel}>
              <SearchAvaRoomInput />
            </div>
          )}
        </section>
      </div>
    </ClickAwayListener>
  );
};

export default InviteCard;
